// extracted by mini-css-extract-plugin
module.exports = {"duplex__wrapper":"Duplex_duplex__wrapper__DnAuo","duplex__column":"Duplex_duplex__column__JCmvA","duplex__column__hidden__mobile":"Duplex_duplex__column__hidden__mobile__jLoz2"};